<div class="title">
    {{ "catalog_pagination_current_page_title" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_text_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="textColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setTextColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setThemeBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-0">
        <label class="col-xs-9 control-label">
            {{ "control_contour_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="borderColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setBorderColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
